import Sticker from "./Sticker";

export default class ElongatedSticker extends Sticker {
    constructor(props) {
        super();
        this.preview_scale_factor = props.hasOwnProperty('preview_scale_factor') ? props.preview_scale_factor : 1.39;
        this.props = {
            font_family: props.font_family,
            background: props.background,
            text_color: props.text_color,
            image: props.image,
            model: props.model,
            first_name: props.first_name,
            last_name: props.last_name,
            image_border: props.image_border,
            data_only: props.data_only,
        }
        this.data = {
            scale: this.preview_scale_factor,
            sizes: {
                width: this.convertToPixels(60) * this.preview_scale_factor,
                height: this.convertToPixels(9) * this.preview_scale_factor
            },
            mm_sizes: {
                width: 60,
                height: 9
            },
            text_coordinates: {
                single: {
                    x: this.convertToPixels(2) * this.preview_scale_factor,
                    y: this.convertToPixels(5.5) * this.preview_scale_factor
                },
                multiple: null
            },
            text_sizes: {
                width: this.convertToPixels(45) * this.preview_scale_factor,
                height: this.convertToPixels(6) * this.preview_scale_factor
            },
            image_coordinates: {
                x: this.convertToPixels(52) * this.preview_scale_factor,
                y: this.convertToPixels(4.5) * this.preview_scale_factor
            },
            image_sizes: {
                width: this.convertToPixels(9) * this.preview_scale_factor,
                height: this.convertToPixels(6) * this.preview_scale_factor
            },
            font_size: this.convertToPixels(6) * this.preview_scale_factor,
            font_weight: 400,
            text_uppercase: false,
            full_name: this.getFullName()
        }
    }
}